module.exports = __webpack_public_path__ + "static/media/main-mobile.2221130b.png";